/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 56dd570fbfc8d3aff994873684002621be61cd7e725a31920f7f4b04f886fb11
 */
import {
  base_contentHover,
} from 'ext-ui/style/colors'
import {
  spacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  align-items: flex-start;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  gap: ${spacing(2)};
  padding-block: ${spacing(3)};
  padding-inline: 20px;
  position: relative;
  text-align: left;
  width: 329px;

  &.default {

    &:hover {
      background: ${base_contentHover};
    }
  }

  &.severe {

    &:hover {
      background: ${base_contentHover};
    }
  }
`
